import {connect} from "react-redux";
import ValetAccountList from "./List";
import {bindActionCreators} from "redux";
import {accountList, getFilter} from "../../../../service/Valet/action";
import {getCityByStateId} from "../../../../service/Account/action";

const mapStateToProps = (state) => ({
    accountDetails:state.Valet.accountListDetails,
    accountFilterContent:state.Valet.accountFilterContent,
    geoCity:state.Dropdown.geoCity,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            accountList,
            getFilter,
            getCityByStateId
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ValetAccountList);
